/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section1_TitleInputs */

const en_terms_section1_title = /** @type {(inputs: Terms_Section1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptance of Terms`)
};

const ko_terms_section1_title = /** @type {(inputs: Terms_Section1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`약관 동의`)
};

const ja_terms_section1_title = /** @type {(inputs: Terms_Section1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`規約への同意`)
};

/**
* | output |
* | --- |
* | "Acceptance of Terms" |
*
* @param {Terms_Section1_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section1_title = /** @type {((inputs?: Terms_Section1_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section1_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section1_title(inputs)
	if (locale === "ko") return ko_terms_section1_title(inputs)
	return ja_terms_section1_title(inputs)
});